function getSubType (context) {
  const path = context.$route.path
  const expr = /\/invoices?\/([a-z]+).*/
  const subtype = expr.exec(path)[1]
  console.assert(subtype)
  return subtype
}

const filterParams = {
  planned: {planned: true},
  numbered: {numbered: true},
  creditnote: {creditnote: true}
}
const overviewTitles = {
  planned: 'Planned Invoices',
  numbered: 'Numbered Invoices',
  creditnote: 'Credit Notes'
}
const detailTitles = {
  planned: 'Planned Invoice',
  numbered: 'Numbered Invoice',
  creditnote: 'Credit Note'
}
const overviewRouterUrls = {
  planned: 'planned_invoices',
  numbered: 'numbered_invoices',
  creditnote: 'creditnote_invoices'
}
const detailRouterUrls = {
  planned: 'planned_invoice',
  numbered: 'numbered_invoice',
  creditnote: 'creditnote_invoice'
}

const fieldsMap = {
  planned:
  [
    {title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center'},
    {title: 'Reference', name: 'document_reference', sortField: 'document_reference', link: '#/invoice/planned/{id}'},
    {title: 'Contract', name: 'contract', sortField: 'contract.name', link: '#/contract/{contract_id}'},
    {title: 'Student Name', name: 'student_name'},
    {title: 'Year', name: 'year', sortField: 'year'},
    {title: 'Semester', name: 'semester', sortField: 'semester'},
    {title: 'Amount to be paid', name: 'amount', sortField: 'amount', callback: 'formatMoney', dataClass: 'text-right'},
    {title: 'Description', name: 'description', sortField: 'description'},
    {title: 'Planned Date', name: 'planned_date', sortField: 'planned_date', callback: 'formatDate', dataClass: 'text-center'},
    {title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp', dataClass: 'text-center'},
    {title: 'Comments', name: 'comments', sortField: 'comments'},
    {title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center'}
  ],
  numbered:
  [
    {title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center'},
    {title: 'Invoice Number', name: 'number', sortField: 'number', link: '#/invoice/numbered/{id}'},
    {title: 'Contract', name: 'contract', sortField: 'contract.name', link: '#/contract/{contract_id}'},
    {title: 'Student Name', name: 'student_name'},
    {title: 'Year', name: 'year', sortField: 'year'},
    {title: 'Semester', name: 'semester', sortField: 'semester'},
    {title: 'Amount invoiced', name: 'total_amount', sortField: 'total_amount', callback: 'formatMoney', dataClass: 'text-right'},
    {title: 'Amount to be paid', name: 'amount', sortField: 'amount', callback: 'formatMoney', dataClass: 'text-right'},
    {title: 'Amount paid', name: 'payed_amount', sortField: 'payed_amount', callback: 'formatMoney', dataClass: 'text-right'},
    {title: 'Date', name: 'invoice_date', sortField: 'invoice_date', callback: 'formatDate'},
    {title: 'Exp. Date', name: 'expiration_date', sortField: 'expiration_date', callback: 'formatDate'},
    {title: 'Ext. Deadline', name: 'extended_deadline_date', sortField: 'extended_deadline', callback: 'formatDate'},
    {title: 'Email Sent', name: 'email_timestamp', sortField: 'email_timestamp', callback: 'formatDate'},
    {title: 'Reminder Sent', name: 'email_reminder_timestamp', sortField: 'email_reminder_timestamp', callback: 'formatDate'},
    {title: 'Credit Note', name: 'credit_note', sortField: 'credit_note'},
    {title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp'},
    {title: 'Comments', name: 'comments', sortField: 'comments'},
    {title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center'}
  ],
  creditnote:
  [
    {title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center'},
    {title: 'Credit Note Number', name: 'number', sortField: 'number', link: '#/invoice/creditnote/{id}'},
    {title: 'Contract', name: 'contract', sortField: 'contract.name', link: '#/contract/{contract_id}'},
    {title: 'Student Name', name: 'student_name'},
    {title: 'Year', name: 'year', sortField: 'year'},
    {title: 'Semester', name: 'semester', sortField: 'semester'},
    {title: 'Amount credited', name: 'total_amount', sortField: 'total_amount', callback: 'formatMoney', dataClass: 'text-right'},
    {title: 'Amount to be paid', name: 'amount', sortField: 'amount', callback: 'formatMoney', dataClass: 'text-right'},
    {title: 'Description', name: 'description', sortField: 'description'},
    {title: 'Date', name: 'invoice_date', sortField: 'invoice_date', callback: 'formatDate'},
    {title: 'Exp. Date', name: 'expiration_date', sortField: 'expiration_date', callback: 'formatDate'},
    {title: 'Ext. Deadline', name: 'extended_deadline_date', sortField: 'extended_deadline', callback: 'formatDate'},
    {title: 'Email Sent', name: 'email_timestamp', sortField: 'email_timestamp', callback: 'formatDate'},
    {title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp'},
    {title: 'Comments', name: 'comments', sortField: 'comments'},
    {title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center'}
  ]
}

export default {
  overviewApiUrl: '/invoices/',
  deleteTitle (context) { return detailTitles[getSubType(context)] },
  disableDelete (rec) { return rec.is_locked },
  subType (context) { return getSubType(context) },
  overviewTitle (context) { return overviewTitles[getSubType(context)] },
  overviewRouterUrl (context) { return overviewRouterUrls[getSubType(context)] },
  getFilterName (context) { return overviewRouterUrls[getSubType(context)] },
  detailTitle (context) { return detailTitles[getSubType(context)] },
  updateNewRoute (context, route) { route.params.subtype = getSubType(context) },
  detailRouterUrl (context) { return detailRouterUrls[getSubType(context)] },
  updateNewRecord (context, rec) {
    // console.log('updateNewRecord', context.$route.params.subtype)
    if (context.$route.params.subtype === 'creditnote') {
      rec.document_type_id = 2
    } else { rec.document_type_id = 1 }
  },
  disableNew (context) { return getSubType(context) !== 'planned' },
  detailApiUrl: '/invoices/',
  quickFilterName: 'Number',
  quickFilterField: 'number',
  advancedSearch: true,
  sortOrder: [
    {
      field: 'number',
      sortField: 'number',
      direction: 'asc'
    }
  ],
  updateFilter (context, params) {
    const subparams = filterParams[getSubType(context)]
    console.assert(subparams)
    Object.assign(params, subparams)
  },
  fields (context) { return fieldsMap[getSubType(context)] }
}
// {
//       "amount": 6000.0,
//       "comments": "",
//       "contract": "2017-00-19192",
//       "contract_id": 1,
//       "creation_timestamp": "2017-08-05T18:21:05.011642Z",
//       "creation_user": "Site Admin",
//       "creation_userid": 1,
//       "date": "2017-06-06T00:00:00Z",
//       "description": "invoice 2017 sem 1",
//       "edit_timestamp": "2017-08-05T18:21:05.011657Z",
//       "edit_user": "Site Admin",
//       "edit_userid": 1,
//       "email_timestamp": null,
//       "email_userid": null,
//       "expiration_date": "2017-07-06T00:00:00Z",
//       "extended_deadline": null,
//       "id": 1,
//       "number": "2017EMINE-19192-01",
//       "planned_date": "2017-05-30T00:00:00Z",
//       "semester": 1,
//       "student_name": "Asanuma Ai",
//       "type": 1,
//       "year": 2017
//     }



// WEBPACK FOOTER //
// ./src/views/Invoice/FieldDefs.js